/* Reservation flow step definitions */
const RESERVATION_STEPS = {
  booking: 1,
  payment: 2,
  complete: 3,
};

const TOTAL_RESERVATION_STEPS = 3;

export { RESERVATION_STEPS, TOTAL_RESERVATION_STEPS };
